<template>
  <div class="head">
    <div class="box">
      <router-link exact to="/" tag="div">
        <img src="../assets/otto/logo.png" alt="" />
      </router-link>
      <ul>
        <li v-for="item in list" :key="item.zhName">
          <a href="#" @click="goto(item.routerName)" :class="{ 'active': section === item.routerName }" >
            <p>{{ item.zhName }}</p>   
            <p>{{ item.enName }}</p>
          <div class="line"></div>
          </a>
        </li>
      </ul>
      <!-- <ul>
        <li>
          <router-link exact :to="{path: '/home#home-anchor'}" tag="div">
            首页
          <p>HOME PAGE</p>
          </router-link>
        </li>
        <li>
          <router-link exact to="/productList" tag="div">
            关于我们
            <p>ABOUT US</p>
          </router-link>
        </li>
        <li>
          <router-link exact to="/news" tag="div">
            产品介绍
            <p>INTRODUCTION</p>
          </router-link>
        </li>
        <li>
          <router-link exact to="/aboutus" tag="div">
            公司优势
            <p>ADVANTAGE</p>
          </router-link>
        </li>
        <li>
          <router-link exact to="/aboutus" tag="div">
            客户案例
            <p>CUSTOMER CASE</p>
          </router-link>
        </li>
        <li>
          <router-link exact to="/aboutus" tag="div">
            核心业务
            <p>bUSINESS</p>
          </router-link>
        </li>
        <li>
          <router-link exact to="/aboutus" tag="div">
            荣誉证书
            <p>CERTIFICATE</p>
          </router-link>
        </li>
      </ul> -->
      <!-- <button class="loginbox" @click="login()">
        {{ loginbtn }}
      </button> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Head',
  components: {},
  data() {
    return {
      launage: '',
      isActive: 1,
      loginbtn: "登录",
      list: [
        {
          zhName: "首页",
          enName: "HOME PAGE",
          routerName: '#home',
        },
        {
          zhName: "关于我们",
          enName: "ABOUT US",
          routerName: '#about'
        },
        {
          zhName: "产品介绍",
          enName: "INTRODUCTION",
          routerName: '#introduction',
        },
        {
          zhName: "公司优势",
          enName: "ADVANTAGE",
          routerName: '#advantage',
        },
        {
          zhName: "客户案例",
          enName: "CUSTOMER CASE",
          routerName: '#case',
        },
        {
          zhName: "核心业务",
          enName: "BUSINESS",
          routerName: '#business',
        },
        {
          zhName: "荣誉证书",
          enName: "CERTIFICATE",
          routerName: '#certificate'
        },
      ],
      section: '#home'
    }
  },
  created() {
      window.onscroll = () => { // 跟随滚动核心代码
            // console.log('页面滚动的距离是：', window.scrollY)
            if(  window.scrollY >= 0 &&  window.scrollY <= 600){
              this.section = '#home'
            }
            if(  window.scrollY > 600 &&  window.scrollY <= 1420){
              this.section = '#about'
            }
            if(  window.scrollY > 1420 &&  window.scrollY <= 2756){
              this.section = '#introduction'
            }
            if(  window.scrollY > 2756 &&  window.scrollY <= 3548){
              this.section = '#advantage'
            }
            if(  window.scrollY > 3548 &&  window.scrollY <= 4280){
              this.section = '#case'
            }
            if(  window.scrollY > 4280 &&  window.scrollY <= 5408){
              this.section = '#business'
            }
            if(  window.scrollY > 5408 &&  window.scrollY <= 6134){
              this.section = '#certificate'
            }
        }
    // i18n.locale = localStorage.getItem('lang')
  },
  mounted() {
    // this.loginbtn = localStorage.getItem('login')
    // this.section = localStorage.getItem("section") || '#home'
    // this.$nextTick(()=>{
    //   this.$scrollTo(this.section)
    // })
    this.loginbtn = sessionStorage.getItem('login') ? sessionStorage.getItem('login') : this.loginbtn;
  },
  computed: {},
  methods: {
    goto(section) {
      this.section = section;
      localStorage.setItem('section', section);
      this.$scrollTo(section)
    },
    changeClass(i) {
      this.isActive = i
      console.log(this.isActive, i)
      if (i == 1) {
        this.$router.push("/")
      }
      else if (i == 2) {
        this.$router.push("/productList")
      }
      else if (i == 3) {
        this.$router.push("/news")
      }
      else if (i == 4) {
        this.$router.push("/aboutus")
      }
    },
    login() {
      if (this.loginbtn == "登录") {
        this.$router.push("/login")
      }
    }
  },
}
</script>
<style lang="less" scoped>
.active {
  color: #fa9600;
}

.router-link-active {
  color: #fa9600;
}

.head {
  width: 100%;
  height: 100px;
  background: rgba(0, 0, 0, 0.24);
  position: fixed;
  top: 0;
  z-index: 9999;
  font-size: 16px;
}

.box {
  width: 1360px;
  height: 100px;
  line-height: 100px;
  margin: auto;
  display: flex;
  font-size: 18px;
  align-items: center;

  img {
    height: 24px;
    vertical-align: middle;
    margin-right: 160px;
  }

  ul {
    flex: 1;
    display: flex;
    justify-content: space-around;

    li {
      height: 100px;
      color: #FFFFFF;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      line-height: 1.6;

      a {
        color: #FFFFFF;
        text-decoration: none;

        p {
          font-size: 16px;
        }
        .line {
          opacity: 0;
          width: 40px;
          height: 3px;
          background-color: #FFFFFF;
          margin: 0 auto;
          margin-top: 6px;
          border-radius: 0 0 4px 4px;
        }

        &.active p{
          color: white;
          font-weight: 600;
        }

        &.active div.line {
          opacity: 1;
        }
      }

      


    }
  }

  .loginbox {
    width: 120px;
    height: 40px;
    border: 1px solid;
    border-color: #000000;
    border-radius: 30px;
    font-size: 16px;
    background: #ffffff;
    cursor: pointer;
  }
}
</style>
